// FLAGS: none
// The single-open-editor lock for the notes panel: which note section is currently being edited.
import React, {
  createContext,
  ReactNode,
  useState,
  useMemo,
  useCallback,
} from "react";

export enum NoteSections {
  THEME,
  TOPICS,
  REASON_BOOK,
  SESSION_DISCUSSED,
  HELP_NEEDED,
  PROVIDER,
  PROVIDER_NAME,
  NEXT_STEPS,
  CA_OTHER_DESCRIPTION,
}

type EditingContextType = {
  editingSection: NoteSections | undefined;
  handleSectionChange: (section: NoteSections | undefined) => void;
  closeEditing: () => void;
};

export const EditingContext = createContext<EditingContextType | null>(null);

interface EditingProviderProps {
  children: ReactNode;
}

export const EditingProvider: React.FC<EditingProviderProps> = ({
  children,
}) => {
  const [editingSection, setEditingSection] = useState<
    NoteSections | undefined
  >(undefined);

  const handleSectionChange = useCallback(
    (section: NoteSections | undefined) => {
      setEditingSection(section);
    },
    [],
  );

  const closeEditing = useCallback(() => {
    setEditingSection(undefined);
  }, []);

  const contextValue = useMemo(
    () => ({
      editingSection,
      handleSectionChange,
      closeEditing,
    }),
    [editingSection, handleSectionChange, closeEditing],
  );

  return (
    <EditingContext.Provider value={contextValue}>
      {children}
    </EditingContext.Provider>
  );
};
